export class BaseRepository {
  get now() {
    return ((Date.now() / 1000) | 0) * 1000;
  }
}
